import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

// --- Facades ---
import { FavoritesFacade } from '@facades/favorites.facade';
import { ParametersFacade } from '@facades/parameters.facade';

@Component({
	selector: 'app-favorites-overlay-panel',
	templateUrl: './favorites-overlay-panel.component.html',
	styleUrls: ['./favorites-overlay-panel.component.scss'],
})
export class FavoritesOverlayPanelComponent {
	@Output() clickOpenFavoritesEvent = new EventEmitter<void>();

	readonly startSlice = 0;
	readonly endSlice = 3;

	readonly favorites$ = this.favoritesFacade
		.getFavorites({ page: 1, pageLimit: this.endSlice }, true)
		.pipe(tap(() => (this.loading = false)));

	objectFit = this.parameters?.allowResizeProductImages ? 'contain' : 'cover';
	loading = true;

	constructor(
		private _router: Router,
		private favoritesFacade: FavoritesFacade,
		private parametersFacade: ParametersFacade
	) {}

	private get parameters() {
		return this.parametersFacade.parameters;
	}

	openFavorites() {
		this.clickOpenFavoritesEvent.emit();
		return this._router.navigate(['/account/favorites']);
	}
}
